import keyBy from 'lodash/keyBy';
/**
 * @deprecated Use keyBy directly
 * @param array
 * @returns
 */
export const documentsToHashObject = (array: unknown[]) => keyBy(array, '_id');
